import { render, staticRenderFns } from "./SettingsCreateClient.vue?vue&type=template&id=98f663ea&scoped=true"
import script from "./SettingsCreateClient.vue?vue&type=script&lang=js"
export * from "./SettingsCreateClient.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateClient.vue?vue&type=style&index=0&id=98f663ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f663ea",
  null
  
)

export default component.exports